import React from 'react';
import styles from './ToggleSwitch.module.css';

const ToggleSwitch = ({ toggled, onClick }) => {
  return (
    <div className={styles.switchContainer} onClick={onClick}>
      <div className={`${styles.switchOption} ${!toggled ? styles.active : ''}`}>
        My Projects
      </div>
      <div className={`${styles.switchOption} ${toggled ? styles.active : ''}`}>
        About Me
      </div>
      <div className={`${styles.slider} ${toggled ? styles.right : ''}`} />
    </div>
  );
};

export default ToggleSwitch;
